import DPTable, { Header } from "Components/DP/DPTable/DPTable";
import DailyPayPaymentRow from "./DailyPayPaymentRow/DailyPayPaymentRow";
import Box from "@material-ui/core/Box";
import React from "react";
import { DPProviderPayment } from "Shared/types/Payments";
import { Typography } from "@material-ui/core";
import { DPEmptyTable } from "Components/DP";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const toDailyPayColumnNames: Header[] = [
  "Received",
  "Type",
  { label: "Account", align: "right" },
  { label: "Payment to DailyPay", align: "right" },
];

type Props = { payments: DPProviderPayment[] };

const DailyPayPayments = ({ payments }: Props) => {
  const { currentProvider, loading } = usePartnerConfig();

  const isWhiteLabelPartner =
    currentProvider?.whiteLabelPartnerIdentifier !== "dailypay";

  const tableTitle = `Payments From ${
    isWhiteLabelPartner ? "Client" : "Partner"
  } to DailyPay`;

  return (
    <Box id="payments-to-daily-pay">
      {!loading && <Typography variant="h3">{tableTitle}</Typography>}
      <DPTable headers={toDailyPayColumnNames}>
        {payments.length ? (
          payments.map((payment) => (
            <DailyPayPaymentRow key={payment.id} {...payment} />
          ))
        ) : (
          <DPEmptyTable message="Detailed activity will appear when payments are received." />
        )}
      </DPTable>
    </Box>
  );
};

export default DailyPayPayments;
